import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import RequireAuth from "../../../auth/middleware/RequireAuth";

interface MenuTabsProps {
    activeTab: string;
    onTabChange: (key: string) => void;
}

const MenuTabsComponent: React.FC<MenuTabsProps> = ({ activeTab, onTabChange }) => {
    const tabs = [
        { label: "Dashboard", key: "dashboard", permissions: ["pms_report_view"] },
        { label: "Occupancy Report", key: "occupancy", permissions: ["pms_report_occupancy_report"] },
        { label: "Agent Report", key: "agent", permissions: ["pms_report_agent_report"] },
        { label: "Revenue Report", key: "revenue", permissions: ["pms_report_revenue_report"] },
        { label: "Sales Report", key: "sales", permissions: ["pms_report_sales_report"] },
        { label: "Payment Report", key: "payment", permissions: ["pms_report_payment_report"] },
        { label: "Extra Report", key: "extra", permissions: ["pms_report_extra_report"] },
        // { label: "Breakfast Report", key: "breakfast", permissions: ["pms_report_breakfast_report"] }, // TODO: Uncomment when API is ready
        // { label: "Transaction Type Report", key: "transaction_type", permissions: ["pms_report_transaction_type_report"] },
        { label: "Housekeeping Forecast Report", key: "housekeeping_forecast", permissions: ["pms_report_housekeeping_forecast_report"] },
    ];

    return (
        <Row className="justify-content-start gap-2">
            {tabs.map((tab) => (
                <RequireAuth requiredRoles={['dev']} requiredPermissions={tab.permissions} key={tab.key} asComponent>
                    <Col xs="auto">
                        <Button
                            variant={activeTab === tab.key ? "primary" : "outline-primary"}
                            onClick={() => onTabChange(tab.key)}
                        >
                            {tab.label}
                        </Button>
                    </Col>
                </RequireAuth>
            ))}
        </Row>
    );
};

export default MenuTabsComponent;
